const SWEDISH_SPANISH_ALIAS_BASENAME = '/spanien';
const NORWEGIAN_SPANISH_ALIAS_BASENAME = '/spania';
const DANISH_SPANISH_ALIAS_BASENAME = '/spanien';
const SPANISH_ALIAS_SOURCE_DOMAIN = 'www.bodex.es';

export const VALUATION_MARKETS = {
  SWEDEN: 'SE',
  NORWAY: 'NO',
  DENMARK: 'DK',
  SPAIN: 'ES'
};

export const isBodexSeHostname = (hostname = '') => {
  const normalized = String(hostname).toLowerCase();
  return normalized === 'bodex.se' || normalized.endsWith('.bodex.se');
};

export const isBodexEsHostname = (hostname = '') => {
  const normalized = String(hostname).toLowerCase();
  return normalized === 'bodex.es' || normalized.endsWith('.bodex.es');
};

export const isBodexNoHostname = (hostname = '') => {
  const normalized = String(hostname).toLowerCase();
  return normalized === 'bodex.no' || normalized.endsWith('.bodex.no');
};

export const isBodexDkHostname = (hostname = '') => {
  const normalized = String(hostname).toLowerCase();
  return normalized === 'bodex.dk' || normalized.endsWith('.bodex.dk');
};

export const isSpanishAliasPath = (pathname = '', hostname = '') => {
  const normalized = String(pathname || '').toLowerCase();
  const normalizedHostname = String(hostname || '').toLowerCase();
  let aliasBasenames = [SWEDISH_SPANISH_ALIAS_BASENAME, NORWEGIAN_SPANISH_ALIAS_BASENAME];
  if (isBodexNoHostname(normalizedHostname)) {
    aliasBasenames = [NORWEGIAN_SPANISH_ALIAS_BASENAME];
  } else if (isBodexSeHostname(normalizedHostname) || isBodexDkHostname(normalizedHostname)) {
    aliasBasenames = [SWEDISH_SPANISH_ALIAS_BASENAME];
  }

  return aliasBasenames.some(
    (basename) => normalized === basename || normalized.startsWith(`${basename}/`)
  );
};

export const isSpanishMarketVisit = (locationLike) => {
  const location = locationLike || (typeof window !== 'undefined' ? window.location : null);
  if (!location) return false;

  const hostname = (location.hostname || '').toLowerCase();
  if (isBodexEsHostname(hostname)) return true;

  if (isBodexSeHostname(hostname)) {
    return isSpanishAliasPath(location.pathname || '', hostname);
  }

  if (isBodexNoHostname(hostname)) {
    return isSpanishAliasPath(location.pathname || '', hostname);
  }

  if (isBodexDkHostname(hostname)) {
    return isSpanishAliasPath(location.pathname || '', hostname);
  }

  return false;
};

export const getSpanishAliasBasename = () => {
  if (typeof window === 'undefined') return '';
  const hostname = (window.location.hostname || '').toLowerCase();
  const pathname = window.location.pathname || '';
  if (!isSpanishAliasPath(pathname, hostname)) return '';
  if (isBodexNoHostname(hostname)) return NORWEGIAN_SPANISH_ALIAS_BASENAME;
  if (isBodexSeHostname(hostname)) return SWEDISH_SPANISH_ALIAS_BASENAME;
  if (isBodexDkHostname(hostname)) return DANISH_SPANISH_ALIAS_BASENAME;
  return '';
};

export const getSpanishAliasSourceDomain = () => SPANISH_ALIAS_SOURCE_DOMAIN;

export const getValuationMarket = (locationLike) => {
  const location = locationLike || (typeof window !== 'undefined' ? window.location : null);
  if (!location) return VALUATION_MARKETS.SWEDEN;

  const hostname = (location.hostname || '').toLowerCase();
  if (isSpanishMarketVisit(location)) return VALUATION_MARKETS.SPAIN;
  if (isBodexNoHostname(hostname)) return VALUATION_MARKETS.NORWAY;
  if (isBodexDkHostname(hostname)) return VALUATION_MARKETS.DENMARK;
  return VALUATION_MARKETS.SWEDEN;
};
